import {TranslateProvider} from "./context/TranslateContext";
import {LoaderProvider} from "./context/LoaderContext";
import {MobileProvider} from "./context/MobileContext";
import {AuthProvider} from "./context/AuthContext";
import {RuoliProvider} from "./context/RuoliContext";
import {FiltersProvider} from "./context/FiltersContext";
import {TabsProvider} from "./context/TabsContext";
import {ParametersProvider} from "./context/ParametersContext";
import {PrimeReactProvider} from 'primereact/api';
import {KpiProvider} from "./context/KpiContext";
import {AlertMsgProvider} from "./context/AlertMsgContext";

function ProvidersComponent({children}) {
    return (
        <TranslateProvider value={localStorage.getItem("sost-lang") || "it"}>
            <PrimeReactProvider>
                <LoaderProvider>
                    <AlertMsgProvider>
                        <MobileProvider>
                            <AuthProvider>
                                <ParametersProvider>
                                    <RuoliProvider>
                                        <FiltersProvider>
                                            <TabsProvider>
                                                <KpiProvider>
                                                    {children}
                                                </KpiProvider>
                                            </TabsProvider>
                                        </FiltersProvider>
                                    </RuoliProvider>
                                </ParametersProvider>
                            </AuthProvider>
                        </MobileProvider>
                    </AlertMsgProvider>
                </LoaderProvider>
            </PrimeReactProvider>
        </TranslateProvider>
    )
}

export default ProvidersComponent;